export default __webpack_public_path__ + "static/media/logo.43cfb0c4.svg";